import { HttpErrorResponse } from "@angular/common/http";

import { GigotException } from "./gigot.exception";

	/**
	 * @description
	 *	Representa un error HTTP aumentado para gestionar los errores
	 *	específicos producidos dentro de la aplicación de Gigot.
	 *
	 * @see gigot-backend/Core/Exception/GigotException.cs
	 */

export class GigotErrorResponse<T = any> extends HttpErrorResponse {

	public readonly error: GigotException<T> | null;
	public readonly isGigotException: boolean;

	public constructor(initialization?: Partial<HttpErrorResponse>) {
		super(initialization);
		this.isGigotException = this.error.source === "Gigot";
	}
}
